var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"deposit-wrap"},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"title"},[_vm._v("保证金")]),_c('span',[_vm._v("奶茶保证金见打款凭证")])])])
}]

export { render, staticRenderFns }